export default 'Candidater au programme partenaires | Solution Éco France';
